/* Live Purchase Notifications */
(function () {
  var citiesArray = [
    'Paris','Lyon','Marseille','Bordeaux','Toulouse','Lille','Nice','Nantes',
    'Strasbourg','Rennes','Grenoble','Rouen','Toulon','Montpellier','Avignon',
    'Saint-Étienne','Tours','Clermont-Ferrand','Nancy','Orléans','Angers',
    'Caen','Metz','Dijon','Le Mans','Reims','Brest','Perpignan','Amiens',
    'Bayonne','Le Havre','Limoges','Nîmes','Dunkerque','Poitiers','Pau',
    'Annecy','Chambéry','Lorient','Troyes','Deauville','Genève','Aix-en-Provence',
    'Valenciennes','Béthune','Douai','Maubeuge','Arras','Lens','Calais',
    'Boulogne-sur-Mer','Saint-Quentin','Laon','Charleville-Mézières','Épinal',
    'Colmar','Mulhouse','Thionville','Forbach','Sarrebourg','Saint-Dié-des-Vosges',
    'Belfort','Besançon','Lons-le-Saunier','Vesoul','Pontarlier','Montbéliard',
    'Auxerre','Chalon-sur-Saône','Mâcon','Beaune','Bourg-en-Bresse','Villefranche-sur-Saône',
    'Valence','Romans-sur-Isère','Vienne','Bourgoin-Jallieu','Voiron','Oyonnax',
    'Albertville','Aix-les-Bains','Thonon-les-Bains','Annemasse','Évian-les-Bains',
    'Gap','Briançon','Embrun','Digne-les-Bains','Manosque','Sisteron',
    'Arles','Salon-de-Provence','Istres','Martigues','Aubagne','La Ciotat',
    'Fréjus','Antibes','Cannes','Grasse','Menton','Monaco','Draguignan',
    'Hyères','La Seyne-sur-Mer','Brignoles','Saint-Raphaël','Saint-Tropez',
    'Narbonne','Sète','Béziers','Carcassonne','Alès','Bagnols-sur-Cèze',
    'Montauban','Albi','Castres','Tarbes','Auch','Rodez','Millau','Figeac',
    'Cahors','Agen','Périgueux','Bergerac','Sarlat-la-Canéda','Brive-la-Gaillarde',
    'Tulle','Ussel','Guéret','La Souterraine','Angoulême','Cognac','Saintes',
    'Rochefort','La Rochelle','Royan','Niort','Fontenay-le-Comte','Bressuire',
    'Châtellerault','Montluçon','Vichy','Moulins','Thiers','Issoire','Riom',
    'Aurillac','Brioude','Le Puy-en-Velay','Yssingeaux','Privas','Aubenas',
    'Montélimar','Nyons','Carpentras','Orange','Apt','Alençon','Lisieux',
    'Cherbourg-en-Cotentin','Saint-Lô','Coutances','Bayeux','Flers','Vire',
    'Évreux','Vernon','Louviers','Luc sur Mer','Fécamp','Elbeuf','Chartres',
    'Châteaudun','Dreux','Rambouillet','Versailles','Évry','Melun',
    'Fontainebleau','Meaux','Créteil','Vincennes','Saint-Denis','Montreuil',
    'Boulogne-Billancourt','Nanterre','Courbevoie','Levallois-Perret',
    'Asnières-sur-Seine','Colombes','Rueil-Malmaison','Argenteuil','Cergy',
    'Pontoise','Saint-Germain-en-Laye','Massy','Palaiseau','Vitry-sur-Seine',
    'Ivry-sur-Seine','Choisy-le-Roi','Laval','Saumur','Cholet','Saint-Nazaire',
    'Vannes','Saint-Brieuc','Quimper','Morlaix','Lannion','Guingamp','Pontivy',
    'Douarnenez','Concarneau','Quimperlé','Landerneau','Saint-Malo','Fougères',
    'Vitré','Dinard','Dinan','Libourne','Arcachon','Mérignac','Pessac',
    'Talence','Le Bouscat','Cenon','Floirac','Lormont','Blois','Amboise',
    'Vendôme','Vierzon','Bourges','Nevers','Châteauroux','Issoudun',
    'Hazebrouck','Saint-Omer','Lausanne','Zurich','Bruxelles','Liège',
    'Namur','Charleroi','Mons','Luxembourg','Sélestat','Haguenau',
    'Saverne','Wissembourg','Obernai','Molsheim','Colmar','Mulhouse',
    'Strasbourg','Metz','Nancy','Épinal','Verdun','Bar-le-Duc','Longwy',
    'Thionville','Sarreguemines','Sarrebourg','Forbach','Saint-Avold',
    'Sartrouville','Noisiel','Torcy','Lognes','Noisy-le-Grand','Bondy',
    'Aulnay-sous-Bois','Bobigny','Pantin','Villepinte','Tremblay-en-France',
    'Garges-lès-Gonesse','Sarcelles','Clichy-sous-Bois','Montfermeil',
    'Rosny-sous-Bois','Neuilly-sur-Marne','Villemomble','Noisy-le-Sec'
  ];

  var delayBetweenMs = 22000;
  var displayDurationMs = 4000;

  function showNextNotification() {
    var boxes = document.querySelectorAll('#live-noti-id .live-noti-box');
    if (!boxes.length) return;

    var randomProductIndex = Math.floor(Math.random() * boxes.length);
    var randomCity = citiesArray[Math.floor(Math.random() * citiesArray.length)];
    var randomMinutes = Math.floor(Math.random() * 29) + 1;

    boxes.forEach(function (box) {
      box.style.visibility = 'hidden';
      box.style.opacity = '0';
      box.style.transition = 'visibility 0s, opacity 0.5s linear';
    });

    var target = boxes[randomProductIndex];
    var cityEl = target.querySelector('.random-city');
    var minEl = target.querySelector('.order-notifications-random');
    if (cityEl) cityEl.textContent = randomCity;
    if (minEl) minEl.textContent = randomMinutes;

    target.style.transition = 'visibility 0s, opacity 0.5s linear';
    target.style.visibility = 'visible';
    target.style.opacity = '1';

    setTimeout(function () {
      target.style.visibility = 'hidden';
      target.style.opacity = '0';
      target.style.transition = 'visibility 1s, opacity 0.5s linear';
    }, displayDurationMs);
  }

  setTimeout(function () {
    showNextNotification();
    setInterval(showNextNotification, delayBetweenMs);
  }, 3000);
})();
